import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import SlideHomeProjects from "./Slide"

function ProjectsIndex() {
  const { i18n, t } = useTranslation();
  var projetcsItems = t("Home.Projects", { returnObjects: true });

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  return (
    <div className="container-fluid home-projects" id="projects">
      <div className="container">
        <div className="row">
        <div className="col-12 d-flex flex-column justify-content-center first-section">
            <div className="col-12 d-flex justify-content-center title-container">
              <div className="title-row d-flex align-items-center justify-content-center">
                <div className="title">
                  {projetcsItems["Projects"]}
                </div>
                <div className="animation-container-title"></div>
              </div>
            </div>
          </div>
          <div className="col-12 d-flex flex-column row-gap-4 second-section">
            <div className="col-12 list">
                <SlideHomeProjects />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectsIndex;